export default __webpack_public_path__ + "static/media/Nocturne_img.5a08bb39.jpg";